import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const fetchAvatar = async () => {
  return apiClient(endpoints.avatar.avatar, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const updateAvatarToProfile = async (params) => {
  return apiClient(endpoints.avatar.avatar, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      body: params,
    }),
  });
};
